/* Copyright (c) 2020-present CloudIO Inc */

import {
  AnalyzeContext,
  AnalyzeIssue,
  AnalyzeResult,
} from 'layout/Sidebar/panels/TreeView/AnalyzeUtils';
import { Item } from '../../registry/Component.type';

export async function analyzeButton({
  platform,
  appUid,
  pageId,
  itemId,
  mgr,
}: AnalyzeContext): Promise<AnalyzeResult> {
  const alerts: AnalyzeIssue[] = [];
  const autoFixes: (() => void)[] = [];
  const page = platform.getPage(appUid, pageId);
  if (!page) {
    return null;
  }
  const item = page[itemId] as Item<'Button'>;
  if (
    item &&
    !item.props.onClickFunction &&
    !item.children?.find((id) => page[id]?.type === 'TriggerOnClick')
  ) {
    alerts.push({
      key: `no-children-${itemId}`,
      showItemId: itemId,
      alert: `${mgr.name} has no trigger on click defined!`,
      itemId,
    });
  }

  return [alerts, autoFixes];
}
